import React from 'react'

export default function MenuClose(props) {
  return (
    <svg width={props.width ? props.width : "14"} height={props.height ? props.height : "14"} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.08333 8.08333L1 1M8.08333 8.08333L15.1667 15.1667M8.08333 8.08333L15.1667 1M8.08333 8.08333L1 15.1667" stroke={props.color ? props.color : "#000"} strokeWidth="1.3333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
